import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

const NotFound: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="p-4 text-center">
      <h2 className="text-3xl font-bold">{t('notFound.title')}</h2>
      <p className="text-lg">{t('notFound.message')}</p>
      <a href="/" className="text-blue-500 hover:underline">
        {t('notFound.goHome')}
      </a>
    </div>
  );
};

export default NotFound;
